import Api from '@/services/Api'

export default {
    putRecord (params) {
      return Api().post('/records', params)
    },

    getPlayerScores() {
      return Api().get('/records')
    },

    clearPlayerScores() {
      return Api().delete('/records')
    }
}